import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import AnnouncementIcon from '@/assets/images/icons/announcement.svg?react';
import type { Group } from '@/models/group/group-info';
import ROUTES from '@/routes';
import { useConversationSessionStore } from '@/stores/conversation-session';
import { generateSessionKey } from '@/utils/session';

interface Props {
  group: Group;
}

export function ConversationNoticeBar({ group }: Props) {
  const { t } = useTranslation();

  const handleDismiss = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    useConversationSessionStore.getState().setLastReadNotice(generateSessionKey(2, group.ID), group.Info);
  };

  return (
    <Link
      className='flex w-full items-center gap-2 border-t-2 border-t-base-100 px-5 py-2 text-body2 inset-x-0 top-16 z-30'
      to={ROUTES.MESSAGES.GROUPS.$.SETTINGS.ANNOUNCEMENT.$path({ relative: true })}>
      <AnnouncementIcon className='size-4 text-primary' />

      <p className='flex-1 truncate w-0'>{group.Info}</p>

      <button
        type='button'
        className='btn btn-link btn-xs font-normal text-secondary'
        onClick={handleDismiss}>
        {t('conversation.group.dismiss-announcement')}
      </button>
    </Link>
  );
}
